import { useEffect, useState } from 'react'

import { isWhatsappInstalled } from '@zet/utils/shareLink'

interface Props {
  customerPhoneNumber?: string
}
const useShouldShowWhatsappShare = (props: Props) => {
  const { customerPhoneNumber } = props
  const [isShouldShowWhatsappShare, setShouldShowWhatsappShare] =
    useState(false)

  useEffect(() => {
    async function load() {
      const res = await isWhatsappInstalled()
      setShouldShowWhatsappShare(res)
    }
    load()
  }, [customerPhoneNumber])
  return isShouldShowWhatsappShare
}

export default useShouldShowWhatsappShare
